import { render, staticRenderFns } from "./List2.vue?vue&type=template&id=25237906"
import script from "./List2.vue?vue&type=script&lang=js"
export * from "./List2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports